/* eslint-disable complexity */
import { useContext } from 'react';
import '~/utils/prototypesExtensions';

import { ErrorBoundary } from '~/components/Tools';

import { Locale } from '@mindtickle/ui-shell-core/Intl';
import { Provider as LoggerProvider } from '@mindtickle/ui-shell-core/Logger';

import Auth, { LocalAuthContext } from '~/components/Auth';
import BaseDomainProvider from '~/components/BaseDomain';

import { NAMESPACE } from '../constants';

const ComponentWithLocale = ({ children }: { children: JSX.Element }) => {
  const auth = useContext(LocalAuthContext);
  return <Locale.Provider locale={auth?.user.locale}>{children}</Locale.Provider>;
};

const ComponentRenderer = ({
  children,
  loader,
  baseDomain,
  appName,
}: {
  children: JSX.Element;
  loader?: JSX.Element;
  baseDomain?: string;
  appName: string;
}) => (
  <LoggerProvider namespace={NAMESPACE}>
    <ErrorBoundary>
      <BaseDomainProvider baseDomain={baseDomain}>
        <Auth loader={loader} appName={appName}>
          <ComponentWithLocale children={children} />
        </Auth>
      </BaseDomainProvider>
    </ErrorBoundary>
  </LoggerProvider>
);

export default ComponentRenderer;
